import { ChangeDetectionStrategy, Component, input, OnDestroy, signal } from '@angular/core';
import { copyToClipboard } from '@mwe/utils';
import { catchError, of, Subscription, tap } from 'rxjs';
import { delay } from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-clipboard-copy-button',
  templateUrl: './clipboard-copy-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class ClipboardCopyButtonComponent implements OnDestroy {
  copyData = input<string>();
  customCopyText = input<string>('shared.clipboardCopy.copy');
  customCopySuccessText = input<string>('shared.clipboardCopy.copySuccess');
  copySuccessFull = signal(false);
  private subscription: Subscription;

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  copyText(): void {
    this.subscription = copyToClipboard(this.copyData())
      .pipe(
        tap(() => this.copySuccessFull.set(true)),
        delay(2000),
        tap(() => this.copySuccessFull.set(false)),
        catchError(() => {
          this.copySuccessFull.set(false);
          return of(null);
        }),
      )
      .subscribe();
  }
}
